export default __webpack_public_path__ + "static/banner-8d2adc59be153fd1ed167c15dbe21c84.jpg";